import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetArchivedSpocProjectsRPC } from "./getArchivedSpocProjectsRPC";

export class GetArchivedSpocProjectsRPCClientImpl extends GetArchivedSpocProjectsRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetArchivedSpocProjectsRPC.Request): Promise<LeoRPCResult<GetArchivedSpocProjectsRPC.Response, GetArchivedSpocProjectsRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "project/GetArchivedSpocProjects",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetArchivedSpocProjectsRPC.ResponseDTO,
      GetArchivedSpocProjectsRPC.Errors.ErrorsDTO,
      GetArchivedSpocProjectsRPC.Response,
      GetArchivedSpocProjectsRPC.Errors.Errors
    >(
      response,
      "project/GetArchivedSpocProjects",
      GetArchivedSpocProjectsRPC.Response.fromDTO,
      GetArchivedSpocProjectsRPC.Errors.fromDTO
    );
  }
}
